import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import CheckoutLayout from "./layouts/CheckoutLayout";
import All from './pages/all'
import './App.css';

const Privacy = lazy(() => import("./pages/privacy"));
const Use = lazy(() => import("./pages/use"));
const Reimbursement = lazy(() => import("./pages/Reimbursement"));
const Checkout = lazy(() => import("./pages/checkout"));
const IptvNederland = lazy(() => import("./pages/seo/IptvNederland"));
const IptvBelgie = lazy(() => import("./pages/seo/IptvBelgie"));
const IptvAbonnement = lazy(() => import("./pages/seo/IptvAbonnement"));
const IptvKopen = lazy(() => import("./pages/seo/IptvKopen"));
const IptvInstalleren = lazy(() => import("./pages/seo/IptvInstalleren"));
const IptvSmartTv = lazy(() => import("./pages/seo/IptvSmartTv"));
const IptvSamsung = lazy(() => import("./pages/seo/IptvSamsung"));
const IptvLg = lazy(() => import("./pages/seo/IptvLg"));
const IptvAndroidTv = lazy(() => import("./pages/seo/IptvAndroidTv"));
const IptvFireTv = lazy(() => import("./pages/seo/IptvFireTv"));
const IptvFormuler = lazy(() => import("./pages/seo/IptvFormuler"));
const WatIsIptv = lazy(() => import("./pages/seo/WatIsIptv"));
const HoeWerktIptv = lazy(() => import("./pages/seo/HoeWerktIptv"));
const IptvGids = lazy(() => import("./pages/seo/IptvGids"));
const IptvBuffert = lazy(() => import("./pages/seo/IptvBuffert"));
const IptvGeenBeeld = lazy(() => import("./pages/seo/IptvGeenBeeld"));
const IptvGeenGeluid = lazy(() => import("./pages/seo/IptvGeenGeluid"));
const IptvEpgWerktNiet = lazy(() => import("./pages/seo/IptvEpgWerktNiet"));
const IptvAppWerktNiet = lazy(() => import("./pages/seo/IptvAppWerktNiet"));
const Iptv4k = lazy(() => import("./pages/seo/Iptv4k"));
const IptvEpg = lazy(() => import("./pages/seo/IptvEpg"));
const IptvMultiDevice = lazy(() => import("./pages/seo/IptvMultiDevice"));
const IptvPrijzen = lazy(() => import("./pages/seo/IptvPrijzen"));

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<All />}/>
          <Route path="/privacypolicy" element={<Privacy />}/>
          <Route path="/termsandconditions" element={<Use />}/>
          <Route path="/refundpolicy" element={<Reimbursement />}/>
          <Route path="/iptv-nederland" element={<IptvNederland />}/>
          <Route path="/iptv-belgie" element={<IptvBelgie />}/>
          <Route path="/iptv-abonnement" element={<IptvAbonnement />}/>
          <Route path="/iptv-kopen" element={<IptvKopen />}/>
          <Route path="/iptv-installeren" element={<IptvInstalleren />}/>
          <Route path="/iptv-smart-tv" element={<IptvSmartTv />}/>
          <Route path="/iptv-samsung" element={<IptvSamsung />}/>
          <Route path="/iptv-lg" element={<IptvLg />}/>
          <Route path="/iptv-android-tv" element={<IptvAndroidTv />}/>
          <Route path="/iptv-fire-tv" element={<IptvFireTv />}/>
          <Route path="/iptv-formuler" element={<IptvFormuler />}/>
          <Route path="/wat-is-iptv" element={<WatIsIptv />}/>
          <Route path="/hoe-werkt-iptv" element={<HoeWerktIptv />}/>
          <Route path="/iptv-gids" element={<IptvGids />}/>
          <Route path="/iptv-buffert" element={<IptvBuffert />}/>
          <Route path="/iptv-geen-beeld" element={<IptvGeenBeeld />}/>
          <Route path="/iptv-geen-geluid" element={<IptvGeenGeluid />}/>
          <Route path="/iptv-epg-werkt-niet" element={<IptvEpgWerktNiet />}/>
          <Route path="/iptv-app-werkt-niet" element={<IptvAppWerktNiet />}/>
          <Route path="/iptv-4k" element={<Iptv4k />}/>
          <Route path="/iptv-epg" element={<IptvEpg />}/>
          <Route path="/iptv-multi-device" element={<IptvMultiDevice />}/>
          <Route path="/iptv-prijzen" element={<IptvPrijzen />}/>
        </Route>
        <Route element={<CheckoutLayout />}>
          <Route path="/checkout" element={<Checkout />}/>
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
